// --- Funções utilitárias ---
function rgbToHex(r, g, b) {
  return "#" + [r, g, b].map(x => {
    const hex = x.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
  }).join("");
}

function lerpColor(hex1, hex2, t) {
  const c1 = parseInt(hex1.slice(1), 16);
  const c2 = parseInt(hex2.slice(1), 16);
  const r1 = (c1 >> 16) & 255, g1 = (c1 >> 8) & 255, b1 = c1 & 255;
  const r2 = (c2 >> 16) & 255, g2 = (c2 >> 8) & 255, b2 = c2 & 255;
  const r = Math.round(r1 + (r2 - r1) * t);
  const g = Math.round(g1 + (g2 - g1) * t);
  const b = Math.round(b1 + (b2 - b1) * t);
  return rgbToHex(r, g, b);
}

// Cor para colunas genéricas
export function colorForGeneric(valor, min, max) {
  if (valor === 0) return "#7f7f7f";
  if (max === min) return "#ffff00"; // tudo igual → amarelo

  const fator = (valor - min) / (max - min); // 0..1
  if (fator <= 0.5) {
    return lerpColor("#FF0000", "#FFFF00", fator / 0.5); // vermelho → amarelo
  } else {
    return lerpColor("#FFFF00", "#00FF00", (fator - 0.5) / 0.5); // amarelo → verde
  }
}

// Cor para coluna TAXA_APLIC
export function colorForTaxaAplicada(valorAplicado, minPrescrito, maxPrescrito, maxAplicado, log=false) {
  if (valorAplicado === 0) return "#7f7f7f"; // cinza para zero

  // Caso especial: prescrição fixa
  if (minPrescrito === maxPrescrito) {
    const alvo = minPrescrito;
    if (alvo === 0) return "#7f7f7f"; // evitar divisão por zero

    const desvio = (valorAplicado - alvo) / alvo; // desvio relativo (%)
    const limite = 1.0; // até ±100% vamos gradear, depois saturamos

    if (Math.abs(desvio) < 0.01) {
      // dentro de 1% do alvo → verde
      return "#00ff00";
    }
    
    
    let r = 0, g = 0, b = 0;

    if (desvio < 0) {
      // aplicou menos que o alvo → verde → amarelo → vermelho
      const t = Math.min(Math.abs(desvio) / limite, 1); // 0..1
      // r = Math.floor(255 * t);         // 0→255
      // g = Math.floor(255 * (1 - t));   // 255→0
      // b = 0;
      if (log)
        console.log("valoraplicado", valorAplicado, ", t", t);
      if (t <= 0.5) {
        r = Math.floor(255 * t / 0.5);
        g = 255;
        b = 0;
      } 
      else {
        // const t = (t - 0.5) / 0.5;
        r = 255;
        g = Math.floor(255 * (1 - ((t - 0.5) / 0.5)));
        b = 0;
      }
      if (log)
        console.log("valor aplicado = ", valorAplicado, ", desvio = ", desvio, "rgb=", r, g, b);
    } 
    else {
      // aplicou mais que o alvo → verde → azul → roxo
      const t = Math.min(desvio / limite, 1); // 0..1
      // r = Math.floor(255 * t);        // 0→255
      // g = Math.floor(255 * (1 - t));  // 255→0
      // b = 255;

      if (t <= 0.5) {
        r = 0;
        g = 255;
        b = Math.floor(255 * t / 0.5);
      } 
      else {
        // const t = (t - 0.5) / 0.5;
        r = 0;
        g = Math.floor(255 * (1 - ((t - 0.5) / 0.5)));
        b = 255;
      }
    }
    if (log)
        console.log("rgbToHex = ", rgbToHex(r, g, b));
    return rgbToHex(r, g, b);
  }

  // Caso normal (faixa prescrita variando por polígono)
  if (valorAplicado < minPrescrito) {
    // gradiente cinza → vermelho
    const fator = valorAplicado / minPrescrito;
    const r = Math.floor(127 + fator * (255 - 127));
    const g = Math.floor(127 - fator * 127);
    const b = Math.floor(127 - fator * 127);
    return rgbToHex(r, g, b);
  } 
  else if (valorAplicado > maxPrescrito) {
    // verde → azul
    const fator = (valorAplicado - maxPrescrito) / (maxAplicado - maxPrescrito);
    const r = 0;
    const g = Math.floor(255 - fator * 255);
    const b = Math.floor(fator * 255);
    return rgbToHex(r, g, b);
  } 
  else {
    // dentro da faixa → vermelho → amarelo → verde
    const fator = (valorAplicado - minPrescrito) / (maxPrescrito - minPrescrito);
    let r, g, b;
    if (fator <= 0.5) {
      const t = fator / 0.5;
      r = 255;
      g = Math.floor(255 * t);
      b = 0;
    } 
    else {
      const t = (fator - 0.5) / 0.5;
      r = Math.floor(255 * (1 - t));
      g = 255;
      b = 0;
    }
    return rgbToHex(r, g, b);
  }
}